/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { actions } from "../../../../../app/modules/Auth/redux/authRedux";
import {
  checkIsActive,
  getCurrentUrl,
  toAbsoluteUrl,
} from "../../../../_helpers";
import { v4 as uuidv4 } from "uuid";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const [activeMenus, setActiveMenus] = useState([]);

  // const getMenuItemActive = (url, hasSubmenu = false) => {
  //   return checkIsActive(location, url)
  //     ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
  //     : "";
  // };
  // const getMenuItemActive = (menuItem, hasSubmenu = false) => {
  //   const currentPath = getCurrentUrl(location);
  //   const parentPath = currentPath?.split("/")[0]
  //   const isActive = (item) => {
  //     if (item.menu_url && currentPath === item.menu_url) {
  //       return true;
  //     }
  //     if (item.children) {
  //       return item.children.some(isActive);
  //     }
  //     return false;
  //   };
  //   return isActive(menuItem)
  //     ? `${!hasSubmenu && "menu-item-active"} menu-item-open`
  //     : "";
  // };
  const getMenuItemActive = (menuItem, hasSubmenu = false) => {
    const currentPath = getCurrentUrl(location);
    const firstSegment = currentPath.split("/")[1]; // Get the first segment of the path
    const isActive = (item) => {
      if (item.menu_url && currentPath === item.menu_url) {
        return true;
      }
      if (item.children) {
        return item.children.some(isActive);
      }
      return activeMenus.length < 1
        ? activeMenus.includes(menuItem.menu_id)
        : false;
    };

    const isParentActive = (item) => {
      const itemPath = item.menu_url?.split("/")[1];
      return activeMenus.length < 1
        ? activeMenus.includes(menuItem.menu_id)
        : itemPath && firstSegment === itemPath;
    };

    return isActive(menuItem)
      ? "menu-item-open menu-item-active"
      : isParentActive(menuItem)
      ? "menu-item-open"
      : "";
  };
  const { menu, user, menuObj, current_active_menu, flatMenu } = useSelector(
    (state) => state.auth
  );

  const { authToken } = useSelector(
    ({ auth }) => ({
      authToken: auth.coreModuleInfo,
    }),
    shallowEqual
  );
  const menuType =
    localStorage.getItem("menuType") &&
    JSON.parse(localStorage.getItem("menuType"));

  const dispatch = useDispatch();
  const menus = useMemo(() => menu ?? [], [menu ?? []]);

  const ordering = [...menus];
  useEffect(() => {
    if (flatMenu) {
      let menu = flatMenu.find((d) => location.pathname == d.menu_url);
      if (menu) {
        let actives = [];
        let currentMenu = menuObj[menu.menu_id];
        const updateActives = (item) => {
          if (item.parent.length) {
            actives.push(item.menu_id);
            for (let menu of item.parent) {
              updateActives(menu);
            }
          } else {
            actives.push(item.menu_id);
          }
        };

        if (currentMenu) {
          updateActives(currentMenu);
        }
        setActiveMenus(actives);
      }
    }
  }, [location.pathname, flatMenu, menuObj]);

  const renderMenuItem = (item) => {
    const {
      title,
      menu_url,
      children,
      menu_icon_class,
      id,
      parent_menu_id,
      sort_number,
      menu_id,
      ...rest
    } = item;
    const ordering = [...children];
    const currentPath = getCurrentUrl(location);

    if (item?.children?.length > 0) {
      return (
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            item,
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
          key={uuidv4()}
          onClick={() => {
            if (menu_url == currentPath) {
              // window.location.href = menu_url;
              if (window.updateRouterInitialKey)
                window.updateRouterInitialKey();
            }
          }}
        >
          <NavLink className="menu-link menu-toggle" to={`${menu_url}` ?? "#"}>
            <span className="svg-icon menu-icon">
              {menu_icon_class ? (
                <i className={`${menu_icon_class} erp_icon`} />
              ) : (
                <i className="menu-bullet menu-bullet-dot">
                  <span />
                </i>
              )}
            </span>
            <span className="menu-text">{title}</span>
            <i className="menu-arrow" />
          </NavLink>
          <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">{title}</span>
                </span>
              </li>

              {/*begin::2 Level*/}
              {ordering &&
                ordering?.length > 0 &&
                ordering
                  ?.sort((a, b) => a?.menu_order - b?.menu_order)
                  ?.map((submenu) => renderMenuItem(submenu))}
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
      );
    }

    return (
      <li
        className={`menu-item ${getMenuItemActive(item, false)}`}
        aria-haspopup="true"
        key={uuidv4()}
        onClick={() => {
          if (menu_url == currentPath) {
            // window.location.href = menu_url;
            if (window.updateRouterInitialKey) window.updateRouterInitialKey();
          }
        }}
      >
        <NavLink className="menu-link" to={`${menu_url}`}>
          <span className="svg-icon menu-icon">
            {menu_icon_class ? (
              <span className="svg-icon menu-icon">
                <i className={`${menu_icon_class} erp_icon`} />
              </span>
            ) : (
              <i className="menu-bullet menu-bullet-dot">
                <span />
              </i>
            )}
          </span>
          <span className="menu-text">{title}</span>
        </NavLink>
      </li>
    );
  };

  return (
    <>
      {/* begin::Menu Nav  */}

      <ul className={`menu-nav ${layoutProps?.ulClasses}`}>
        {ordering &&
          ordering?.length > 0 &&
          ordering
            ?.sort((a, b) => a?.menu_order - b?.menu_order)
            ?.map((menu, i) => renderMenuItem(menu))}
      </ul>
    </>
  );
}
